module.exports = __webpack_public_path__ + "static/media/screen3.43735d6b.png";